import * as React from "react"
import styled from "styled-components"
import { History } from "history"
import { Subscribe } from "unstated"
import { Link, Redirect } from "react-router-dom"
import qs from "qs"
import AuthenticationState from "src/hoc/authentication/authentication.state"
import { FetchSingleListingComponent, UserType } from "src/generated/graphql"
import theme, { Colors } from "src/theme/"
import TolobiLoader from "src/components/tolobi-loader"
import Error from "src/components/error"
import Column from "src/components/column"
import BookingWidget from "src/components/booking-widget"
import Text from "src/components/text"
import SingleListingGallerySection from "src/components/single-listing-gallery-section"
import SingleListingAboutSection from "src/components/single-listing-about-section"
import SingleListingHighlights from "src/components/single-listing-highlights-section"
import SingleListingAmenitiesSection from "src/components/single-listing-amenities-section"
import SingleListingMoveInBonusesSection from "src/components/single-listing-move-in-bonuses-section"
import SingleListingRequirementsSection from "src/components/single-listing-requirements-section"
import SingleListingUtilitiesSection from "src/components/single-listing-utilities-section"
import SingleListingPetsSection from "src/components/single-listing-pets-section"
import SingleListingUnitsSection from "src/components/single-listing-units-section"
import SingleListingLandlordSection from "src/components/single-listing-landloard"
import SingleListingRoommatesSection from "src/components/single-listing-roommates-section"
import SingleListingStaticMap from "src/components/single-listing-static-map"
import SingleListingSimilarListings from "src/components/single-listing-similar-listings-section"
import Footer from "src/components/footer"
import ReactHelmet from "src/components/react-helmet"
import moment from "moment"
import { ListingIsPremium } from "src/components/listing-card/listing-card.component"
import GoogleAdSense from "src/components/google-ad-sense/google-ad-sense"
import { checkAllAccess } from "src/utils/comman-methods"
import NoListing from "src/components/listing-not-found/NoListing"
import { Alert, Space } from 'antd';

const NotAvailableWrapper = styled.div`
    font-size:17px;
    font-weight: 600;
    border: 1px solid red;
    border-radius: 3px;
    padding: 4px;
    color:red;
`

const TitleMain = styled.div`
margin-bottom:32px;
display:flex; 
justify-content: space-between;
align-items: center;
`
const SingleListingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${Colors.primary};
`

const ContentWrapper = styled(Column as any)`
  max-width: 1204px;
  margin: 0 auto;
  margin-bottom: 28px;
  @media (max-width: ${theme.breakpoints[1]}) {
    margin: initial;
    width: 100%;
  }
`
const MobileBookingWidgetWrapper = styled.div`
  @media (min-width: ${theme.breakpoints[1]}) {
    display: none;
  }
`
const DesktopBookingWidgetWrapper = styled.div`
  position: sticky;
  top: -200px;
  transform: translateY(330px);
  width: 390px;
  align-self: flex-end;
  margin-top: -112px;
  margin-bottom: 254px;
  margin-right: -414px;
  @media (max-width: ${theme.breakpoints[1]}) {
    display: none;
    margin-bottom: 0;
  }
`

const StyledTitle = styled.h1`
  text-decoration: none;
  margin-bottom: 32px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 32px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: rgb(60, 66, 64);
  text-transform: capitalize;
  @media (min-width: 640px) {
    white-space: pre-line;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const TitleSeaction = styled.div`
  display: flex;
  align-items: center;
`
const FeatureTitleWrapper = styled.div`
  margin-left: 25px;
  margin-bottom: 25px;
`

const StyledColumn = styled(Column as any)`
  margin-top: -470px;
  margin-bottom: 56px;
  max-width: 730px;
  width: calc(100% - 390px);
  @media (max-width: ${theme.breakpoints[1]}) {
    margin-top: 16px;
    margin-bottom: 0px;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }
`

const EditButton = styled.div`
   margin-left:15px;
   border:1px solid ${Colors.primary}
   padding:.1rem 1rem
   color: ${Colors.darkGrey};
   border-radius:6px;
   &:hover{
    cursor:pointer
   }

`

const TextWithOffset = styled(Text as any)`
  fontsize: 18px;
  color: ${Colors.darkGrey};
  align-items:center;
  display:flex;
  @media (max-width: ${theme.breakpoints[1]}) {
    margin-top: 0;
  }
`
interface Props {
  match: {
    isExact: boolean
    params: {
      id: string
    }
  }
  history: History
  authState: any
}
class SingleListing extends React.PureComponent<Props, null> {
  checkAccessValid = user => {
    if (user && user?.userType === UserType.SubAdmin)
      return checkAllAccess(user?.permissions, "listings")
    else return null
  }

  render() {
    const { match, history } = this.props
    return (
      <FetchSingleListingComponent
        variables={{
          where: {
            id: match.params.id
          }
        }}
      >
        {({ loading, data, error }) => {
          if (loading) {
            return <TolobiLoader />
          }
          if (error) {
            console.log({ error })
            return <Error />
          }
          if (!data || !data.listing) {
            return <NoListing />
          }

          const hasPremium =
            moment.unix(data.listing?.premiumStart / 1000).isBefore(moment()) &&
            moment.unix(data.listing?.premiumEnd / 1000).isAfter(moment())

          const location =
            data &&
            data.listing.location &&
            data.listing.location.neighbourHood &&
            data.listing.location.neighbourHood.city.name

          const query = qs.parse(history.location.search, {
            ignoreQueryPrefix: true
          })

          if (location && !query.location) {
            history.replace({
              search: qs.stringify({
                location,
                title: data.listing.title
              })
            })
          }

          return (
            <Subscribe to={[AuthenticationState]}>
              {(authState: any) => {
                const permission = this.checkAccessValid(authState?.state?.user)

                return (
                  <SingleListingWrapper>
                    <ReactHelmet
                      url="listing"
                      title={data && data.listing && data.listing.title}
                      description={data && data.listing && data.listing.description}
                      city={
                        data.listing.location &&
                        data.listing.location.neighbourHood &&
                        data.listing.location.neighbourHood.city &&
                        data.listing.location.neighbourHood.city.name
                      }
                      id={data && data.listing && data.listing.id}
                      pageType='single-listing'
                    />
                    <SingleListingGallerySection pictures={data.listing.pictures} />
                    <ContentWrapper px={["8px", "16px"]} width={["95%"]}>
                      <StyledColumn>
                        <DesktopBookingWidgetWrapper>
                          <BookingWidget
                            history={history}
                            listingID={data.listing.id}
                            units={data.listing.units}
                          />
                          {/* <div style={{ marginTop: 100 }}>
                            <GoogleAdSense
                              styles={{
                                width: "100%",
                                height: 250,
                                float: "left",
                                backgroundColor: "red"
                              }}
                            />
                          </div> */}

                          <Space direction="vertical" style={{ width: '100%', marginTop: "20px" }}>
                            <Alert
                              message="Protect yourself!"
                              description="Please hold off sending any money until you see the property in person and have an agreement in writing with the landlord or the property manager."
                              type="warning"
                              showIcon
                            />
                          </Space>
                        </DesktopBookingWidgetWrapper>

                        <TitleMain>
                          <TextWithOffset>
                            {(data.listing.location &&
                              data.listing.location.neighbourHood &&
                              data.listing.location.neighbourHood.city &&
                              data.listing.location.neighbourHood.city.name) || (data.listing.location && data.listing.location?.address?.split(',')[1]) ||
                              ""}
                            {
                              data.listing.location && data.listing.location.neighbourHood
                                ? " · "
                                : ""
                            }
                            {(data.listing.location &&
                              data.listing.location.neighbourHood &&
                              data.listing.location.neighbourHood.name) ||
                              ""}
                            {data &&
                              data.listing &&
                              data.listing.user &&
                              authState.state.user &&
                              authState.state.user.id &&
                              data.listing.user.id === authState.state.user.id && (
                                <Link
                                  to={{
                                    pathname: `/building`,
                                    search: `edit/id=${data.listing.id}`
                                  }}
                                >
                                  <EditButton>Edit</EditButton>
                                </Link>
                              )}
                            {permission?.edit ? (
                              <Link
                                to={{
                                  pathname: `/listings`,
                                  search: `edit=true/id=${data.listing.id}`
                                }}
                              >
                                <EditButton>Edit</EditButton>
                              </Link>
                            ) : null}

                          </TextWithOffset>
                          {data?.listing?.isHidden ?
                            (<NotAvailableWrapper >Not Available</NotAvailableWrapper>) : ""}
                        </TitleMain>
                        <TitleSeaction>
                          <StyledTitle color={Colors.darkGrey} mb="32px">
                            {data.listing.title}
                          </StyledTitle>
                          {hasPremium && (
                            <FeatureTitleWrapper>
                              <ListingIsPremium>Featured</ListingIsPremium>
                            </FeatureTitleWrapper>
                          )}
                        </TitleSeaction>

                        <MobileBookingWidgetWrapper>
                          <Column my="63px">
                            <BookingWidget
                              history={history}
                              listingID={data.listing.id}
                              units={data.listing.units}
                            />
                          </Column>
                          <div>
                            <Space direction="vertical" style={{ width: '100%', marginBottom: "50px", padding: "7px" }}>
                              <Alert
                                message="Protect yourself!"
                                description="Please hold off sending any money until you see the property in person and have an agreement in writing with the landlord or the property manager."
                                type="warning"
                                showIcon
                              />
                            </Space>
                          </div>
                        </MobileBookingWidgetWrapper>
                        <SingleListingHighlights
                          propertyType={data.listing.propertyType}
                          units={data.listing.units}
                        />
                        <SingleListingAboutSection description={data.listing.description} />
                        {/*HERE GOOGLE ADD*/}
                        <GoogleAdSense
                          styles={{
                            width: "100%",
                            height: 180,
                            float: "left"
                          }}
                        />

                        <SingleListingMoveInBonusesSection
                          value={data.listing?.moveInBonuses || "None"}
                        />
                        <SingleListingAmenitiesSection amenities={data.listing.amenities} />
                        <SingleListingRequirementsSection
                          requirements={data.listing.tenantRequirements}
                        />

                        <SingleListingUtilitiesSection utilities={data.listing.utilities} />
                        <SingleListingPetsSection pets={data.listing.pet} />
                        <SingleListingUnitsSection units={data.listing.units} />
                        <SingleListingLandlordSection owner={data.listing.user} />

                        {authState && authState.state.user && (
                          <SingleListingRoommatesSection match={this.props.match} />
                        )}

                        {data.listing.location && data.listing.location.neighbourHood && (
                          <SingleListingStaticMap location={data.listing.location} />
                        )}
                      </StyledColumn>
                      <SingleListingSimilarListings match={this.props.match} />
                      <GoogleAdSense
                        styles={{
                          width: "100%",
                          height: 250,
                          float: "left"
                        }}
                      />
                    </ContentWrapper>
                    <Footer />
                  </SingleListingWrapper>
                )
              }}
            </Subscribe>
          )
        }}
      </FetchSingleListingComponent>
    )
  }
}

export default SingleListing
